var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-bar"},[_c('p',[_vm._v("\n    Copyright © "+_vm._s(new Date().getFullYear())+"湖南柒扣文化科技有限公司版权所有     \n\n    "),_c('span',{staticClass:"footerHover",staticStyle:{"cursor":"pointer"},on:{"click":_vm.jumpWeb}},[_vm._v("湘ICP备2023004439号")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726a5d04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Footer.vue
// module id = null
// module chunks = 